import { render, staticRenderFns } from "./CreditHistoryTable.vue?vue&type=template&id=337ebe2d"
import script from "./CreditHistoryTable.vue?vue&type=script&lang=js"
export * from "./CreditHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports